import { HistoryLoader } from "../HistoryTable";

export function HistoryTab({ sku, version }: { sku: string; version: number }) {
  return <HistoryLoader sku={sku} version={version} />;
}
